<template>
  <div class="risk-score__wrapper">
    <div class="risk-score__header">
      <div class="risk-score__status-wrapper">
        {{ score != null ? 'Risk Score:' : 'Risk Score' }}
        <ScoreStatus
          :loading="loading"
          :value="score"
        />
      </div>
      <BuyButton
        v-if="!getPurchasedInfo.risks && !getIsLegacy && !isMobile"
        type="risks"
      />
    </div>

    <GlBarEqualizer
      :key="isMobile"
      :loading="loading"
      :total-bars="isMobile ? 30 : 40"
      :value="score"
    />
  </div>
</template>

<script>
// Components
import ScoreStatus from '@/pages/report/components/risks-info/ScoreStatus'
import GlBarEqualizer from '@/components/charts/gl-bar-equalizer'
import BuyButton from '@/pages/report/components/section-components/BuyButton'
//mixins
import deviceWidthMixin from '@/assets/mixins/deviceWidthMixin'
// vuex
import { mapGetters } from 'vuex'

export default {
  name: 'RiskScore',
  components: { GlBarEqualizer, ScoreStatus, BuyButton },
  mixins: [deviceWidthMixin],
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    score: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    ...mapGetters('report', ['getPurchasedInfo', 'getIsLegacy']),
  },
}
</script>
<style scoped>
.risk-score__wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.risk-score__header {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  width: 100%;
}
.risk-score__wrapper::v-deep .gl-bar-equalizer {
  max-width: 527px;
}
.risk-score__status-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--Size-3XL, 24px);
  font-weight: 700;
  line-height: var(--Line-Height-3XL, 32px);
}

@media (max-width: 767px) {
  .risk-score__status-wrapper {
    font-size: var(--Size-2XL, 20px);
  }
}
</style>
